import { Chip, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';

const ContactsColumns = ({ onCompareDuplicates } = {}) => {
    // -- Define the breakpoints -- //
    const isMobile = useMediaQuery('(max-width:600px)');

    return [
        {
            field: "organizationName",
            headerName: "Organization",
            flex: 1,
            cellClassName: "name-column--cell",
          },
                {
                    field: "name",
                    headerName: "Name",
                    flex: 1,
                    minWidth: 150,
                    renderCell: ({ row }) => (
                        <Link className="hive-grid-link-cell" to={`/contacts/${row._id}`} onClick={(event) => event.stopPropagation()}>
                            {row.name || [row.firstName, row.lastName].filter(Boolean).join(' ') || row.primaryEmail || 'View contact'}
                        </Link>
                    )
                },
            {
                field: 'duplicateCount',
                headerName: 'Possible Duplicate',
                type: 'number',
                width: 185,
                align: 'left',
                headerAlign: 'left',
                renderCell: ({ row }) => row.duplicateCount > 0 ? <Chip
                    label={`Review (${row.duplicateCount})`} color="warning" variant="outlined" size="small"
                    aria-label={`Compare ${row.duplicateCount} possible duplicates for ${row.name || row.primaryEmail || 'contact'}`}
                    onClick={event => { event.stopPropagation(); onCompareDuplicates?.(row); }}
                /> : null,
            },
            ...(isMobile ? [] : [
                {
                    field: "primaryEmail",
                    headerName: "Email",
                    flex: 1
                },
                {
                    field: "phoneNumber",
                    headerName: "Phone #",
                    flex: 1
                },
            ]),
    ];
};

export default ContactsColumns
